import { atom } from "jotai";
import { sideBarSelectedAtom } from "./sideBarSelectedAtom";

// Not used for copilot - use useCopilotDrawerState (in a component) or copilotDrawerStateAtom (in another atom) for copilot states
export const closeSidebarSetter = atom(null, (_, set) => {
  set(sideBarSelectedAtom, null);
});

closeSidebarSetter.debugLabel = "closeSidebarSetter";
